import { Mic, Music2, Headphones, PlayCircle, CalendarDays, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { DISCOVER_CARDS } from "../lib/constants";

const iconMap = { Mic, Music2, Headphones, PlayCircle, CalendarDays };

export default function DiscoverMore() {
    return (
        <section data-testid="discover-more-section" className="mt-16">
            <div className="flex items-end justify-between mb-6">
                <h2 className="brand-section font-display uppercase text-3xl md:text-5xl tracking-tight text-white">
                    Discover More
                </h2>
                <span className="overline text-streetz-muted hidden md:inline-block">
                    EXPLORE THE CULTURE
                </span>
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-5 gap-4 md:gap-6">
                {DISCOVER_CARDS.map((c) => {
                    const Icon = iconMap[c.icon];
                    return (
                        <Link
                            to={c.to}
                            key={c.key}
                            data-testid={`discover-card-${c.key}`}
                            className="group relative aspect-[4/5] bg-streetz-paper border border-streetz-line overflow-hidden hover:border-streetz-yellow transition-colors"
                        >
                            <img
                                src={c.image}
                                alt={c.title}
                                className="absolute inset-0 w-full h-full object-cover opacity-60 group-hover:opacity-90 transition-opacity"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/10" />
                            <div className="relative p-5 h-full flex flex-col justify-between">
                                <div className="h-12 w-12 rounded-full bg-streetz-yellow grid place-items-center text-black">
                                    <Icon className="w-6 h-6" />
                                </div>
                                <div>
                                    <h3 className="font-display uppercase text-2xl text-white">
                                        {c.title}
                                    </h3>
                                    <p className="text-sm text-streetz-muted mt-2">
                                        {c.desc}
                                    </p>
                                    <span className="mt-4 inline-flex items-center gap-2 overline text-white group-hover:text-streetz-yellow">
                                        EXPLORE <ArrowRight className="w-3 h-3" />
                                    </span>
                                </div>
                            </div>
                        </Link>
                    );
                })}
            </div>
        </section>
    );
}
